const theme = {
  primary: "#9265FB",
  secondary: "#191D63",
  gray: "#F3F8F9",
};

export default theme;
